import React, { useRef } from "react";
import NoteAttachmentDownloadButton from "./NoteAttachmentDownloadButton";
import {
  NOTE_ATTACHMENT_ACCEPT,
  formatNoteAttachmentSize,
  validateNoteAttachment,
} from "../../utils/noteAttachments";

function NoteAttachmentUpload({ attachments = [], onChange, disabled = false }) {
  const fileInputRef = useRef(null);

  const handleSelectFiles = (event) => {
    const selectedFiles = Array.from(event.target.files || []);
    event.target.value = "";

    if (!selectedFiles.length) {
      return;
    }

    const nextAttachments = [...attachments];
    const errors = [];

    selectedFiles.forEach((file) => {
      const validation = validateNoteAttachment(file);
      if (!validation.valid) {
        errors.push(`${file.name}: ${validation.error}`);
        return;
      }

      nextAttachments.push({
        id: `pending-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        fileName: file.name,
        mimeType: file.type,
        fileSize: file.size,
        file,
      });
    });

    if (errors.length) {
      window.alert(errors.join("\n"));
    }

    if (nextAttachments.length !== attachments.length) {
      onChange?.(nextAttachments);
    }
  };

  const handleRemove = (attachmentId) => {
    onChange?.(attachments.filter((attachment) => attachment.id !== attachmentId));
  };

  return (
    <div className="my-notes-attachments">
      <ul className="my-notes-attachment-list" aria-live="polite">
        {attachments.map((attachment) => (
          <li key={attachment.id} className="my-notes-attachment-item">
            <span className="my-notes-attachment-name" title={attachment.fileName}>
              {attachment.fileName}
            </span>
            {attachment.url || attachment.file ? (
              <NoteAttachmentDownloadButton attachment={attachment} />
            ) : null}
            <span className="my-notes-attachment-size">
              {formatNoteAttachmentSize(attachment.fileSize)}
            </span>
            <button
              type="button"
              className="my-notes-attachment-remove"
              aria-label={`Remove ${attachment.fileName}`}
              onClick={() => handleRemove(attachment.id)}
              disabled={disabled}
            >
              ×
            </button>
          </li>
        ))}
      </ul>

      <div className="my-notes-attachments-actions">
        <input
          ref={fileInputRef}
          type="file"
          className="my-notes-attachment-input"
          accept={NOTE_ATTACHMENT_ACCEPT}
          multiple
          onChange={handleSelectFiles}
          disabled={disabled}
          aria-hidden="true"
          tabIndex={-1}
        />
        <button
          type="button"
          className="my-notes-upload-button"
          onClick={() => fileInputRef.current?.click()}
          disabled={disabled}
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 16V4m0 0l-4 4m4-4l4 4M4 20h16" />
          </svg>
          Upload
        </button>
        <span className="my-notes-attachments-hint">
          Add your supporting docs (pdf, docx, images • max 10 MB)
        </span>
      </div>
    </div>
  );
}

export default NoteAttachmentUpload;
